import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Client
import { Login as ClientLogin } from "../Views/Client/Login";
import { NewOrder } from "../Views/Client/NewOrder";
import { Address } from "../Views/Client/Address";
import { ClientInfo } from "../Views/Client/ClientInfo";
import { Payment } from "../Views/Client/Payment";
import { OrderConfirm } from "../Views/Client/OrderConfirm";
import { OrderStatus } from "../Views/Client/OrderStatus";

// Admin
import { Login as AdminLogin } from "../Views/Admin/Login";
import { Orders as AdminOrders } from "../Views/Admin/Orders";
import { OrderDetails as AdminOrderDetails } from "../Views/Admin/OrderDetails";
import { Entities as AdminEntities } from "../Views/Admin/Entities";
import { AdminUpdatePrices } from "../Views/Admin/UpdatePrices";
import { AdminUpdateAnillado } from "../Views/Admin/UpdatePrices/UpdateAnillado";

import useResponsive from "../hooks/useResponsive";

import ProtectedRoute from "./ProtectedRoute";
import { Instructions } from "../Views/Client/Instructions";

const Router = ({ children }: any) => {
  const { pathname } = useLocation();
  const { isTabletOrMobile } = useResponsive();

  // [Mobile] scroll to top when changing route
  useEffect(() => {
    if (isTabletOrMobile) {
      window.scrollTo(0, 0);
    }
  }, [pathname, isTabletOrMobile]);

  return children;
};

export const routes = {
  clientLogin: {
    path: "/",
    element: <Router children={<ClientLogin />} />,
  },
  clientInstructions: {
    path: "/client/instructions",
    element: <Router children={<Instructions />} />,
  },
  clientNewOrder: {
    path: "/client/new-order",
    element: <Router children={<NewOrder />} />,
  },
  clientAddress: {
    path: "/client/address",
    element: <Router children={<Address />} />,
  },
  clientInfo: {
    path: "/client/info",
    element: <Router children={<ClientInfo />} />,
  },
  clientPayment: {
    path: "/client/payment",
    element: <Router children={<Payment />} />,
  },
  clientOrderConfirm: {
    path: "/client/confirm",
    element: <Router children={<OrderConfirm />} />,
  },
  clientOrderStatus: {
    path: "/client/order/:trackingCode",
    element: <Router children={<OrderStatus />} />,
  },
  adminLogin: {
    path: "/admin",
    element: <Router children={<AdminLogin />} />,
  },
  adminOrders: {
    path: "/admin/orders",
    element: (
      <Router 
        children={
          <ProtectedRoute>
            <AdminOrders />
          </ProtectedRoute>
        } 
      />
      ),
    },
  adminOrdersDetails: {
    path: "/admin/order/details",
    element: (
      <Router
        children={
        <ProtectedRoute>
          <AdminOrderDetails />
        </ProtectedRoute>
        }
      />
    ),
  },
  adminEntities: {
    path: "/admin/entities",
    element: (
      <Router
        children={
          <ProtectedRoute>
            <AdminEntities />
          </ProtectedRoute>
        } 
      />
    ),
  },
  adminUpdatePrices: {
    path: "/admin/update-prices",
    element: (
      <Router
        children={
          <ProtectedRoute>
            <AdminUpdatePrices />
          </ProtectedRoute>
        } 
      />
    ),
  },
  adminUpdateAnillado: {
    path: "/admin/update-anillado",
    element: (
      <Router
        children={
          <ProtectedRoute>
            <AdminUpdateAnillado />
          </ProtectedRoute>
        } 
      />
    ),
  },
};

export const getRoutes = () =>
  Object.keys(routes).map((key: string) => {
    return {
      // @ts-ignore
      path: routes[key].path,
      // @ts-ignore
      element: routes[key].element,
    };
  });
